module.exports = __webpack_public_path__ + "static/media/Icons_pause_hiring.4ae39b13.svg";